<!-- ===== MODUS-AUSWAHL (noch nicht konfiguriert) ===== -->


@if (this.fusionService.selectedHtmlPage && (!this.fusionService.selectedHtmlPage.metadata.proxyUrl &&
!this.fusionService.selectedHtmlPage.metadata.useStaticHtml)) {
@if (!this.showUrlInput) {
<div>
  <p>
    <b i18n="@@embed-html">HTML-Inhalt einbinden</b><br>
    <span i18n="@@embed-html-choose-mode">
      Wie soll die Fusion-View-Seite aufgebaut werden?
    </span>
  </p>
  <div class="row g-3">
    <div class="col-6">
      <div
        class="card mode-card h-100 text-center p-4"
        (click)="this.fusionService.updateFusionField('useStaticHtml', true)"
      >
        <div>
          <i class="ri-code-s-slash-line ri-3x text-primary"></i>
        </div>
        <h6
          class="mt-2 mb-1"
          i18n="@@mode-custom-html-title"
        >Eigenes Seitenlayout</h6>
        <p
          class="text-secondary small mb-0"
          i18n="@@mode-custom-html-desc"
        >
          Die gesamte Seite direkt hier im Editor anlegen, bearbeiten und gestalten. So hast du die maximale
          Gestaltungsfreiheit.
        </p>
      </div>
    </div>
    <div class="col-6">
      <div
        class="card mode-card h-100 text-center p-4"
        (click)="this.showUrlInput = true"
      >
        <div>
          <i class="ri-global-line ri-3x text-primary"></i>
        </div>
        <h6
          class="mt-2 mb-1"
          i18n="@@mode-url-title"
        >Remote-Template</h6>
        <p
          class="text-secondary small mb-0"
          i18n="@@mode-url-desc"
        >
          Das Seitenlayout wird von einer externen URL geladen. So können Vorlagen zentral verwaltet und für mehrere
          Fusion-Views wiederverwendet werden.
        </p>
      </div>
    </div>
  </div>
</div>
}
@if (this.showUrlInput) {
<div>
  <p-button
    [text]="true"
    severity="secondary"
    icon="ri-arrow-left-s-line"
    (onClick)="this.showUrlInput = false"
    i18n-label="@@back-to-mode-selection"
    label="Zurück zur Auswahl"
  ></p-button>
  <div class="mt-3">
    <h6 i18n="@@url-proxy-heading">Remote-Template verwenden</h6>
    <p
      class="text-secondary mb-3"
      i18n="@@url-proxy-description"
    >
      Gib die URL zu einem HTML-Template ein, das auf einem externen Server liegt.
      Bei jedem Aufruf des Fusion-Views wird das Template von dort geladen und
      Platzhalter wie ___BOTID automatisch ersetzt. So kannst du Layouts zentral
      pflegen und für mehrere Fusion-Views nutzen.
    </p>
    <label
      class="form-label fw-semibold"
      for="proxyUrlInput"
      i18n="@@url-proxy-label"
    >Template-URL</label>
    <input
      pInputText
      id="proxyUrlInput"
      #urlInput
      type="text"
      class="w-100"
      placeholder="https://example.com"
    />
    <div class="mt-3">
      <p-button
        styleClass="me-2"
        size="small"
        severity="primary"
        icon="ri-link"
        (onClick)="this.addURL(urlInput.value)"
        i18n-label="@@use-url-as-proxy"
        label="Remote-Template verwenden"
      ></p-button>
      <!--  <p-button
          size="small"
          [outlined]="true"
          severity="secondary"
          icon="ri-code-s-slash-line"
          (onClick)="this.loadURL(urlInput.value)"
          i18n-label="@@use-as-custom-html"
          label="Quelltext laden &amp; lokal bearbeiten"
        ></p-button> -->
    </div>
    <!--  <p
      class="text-secondary small mt-3 mb-0"
      i18n="@@url-proxy-hint"
      >
      <i class="ri-information-line me-1"></i>
      <b>Remote-Template verwenden</b> lädt das Layout bei jedem Aufruf von der angegebenen URL. Änderungen am
      Template wirken sich sofort auf alle Fusion-Views aus, die es nutzen.
      <b>Quelltext laden &amp; lokal bearbeiten</b> kopiert den aktuellen Quelltext der URL einmalig in den Editor. Ab
      dann wird das Layout hier lokal gepflegt.
    </p> -->
  </div>
</div>
}
}

<!-- ===== KONFIGURIERTER ZUSTAND (URL oder Custom HTML) ===== -->
@if (this.fusionService.selectedHtmlPage && (this.fusionService.selectedHtmlPage.metadata.proxyUrl ||
this.fusionService.selectedHtmlPage.metadata.useStaticHtml)) {
<!-- Modus-Anzeige -->
<div class="mode-indicator d-flex justify-content-between align-items-center mb-3">
  @if (!this.fusionService.selectedHtmlPage.metadata.useStaticHtml) {
  <span>
    <i class="ri-global-line me-2"></i>
    <b i18n="@@current-mode-url">Modus: Remote-Template</b>
  </span>
  }
  @if (this.fusionService.selectedHtmlPage.metadata.useStaticHtml) {
  <span>
    <i class="ri-code-s-slash-line me-2"></i>
    <b i18n="@@current-mode-custom">Modus: Eigenes Seitenlayout</b>
  </span>
  }
  <p-button
    size="small"
    [text]="true"
    severity="secondary"
    icon="ri-refresh-line"
    (onClick)="this.resetMode()"
    i18n-label="@@change-mode"
    label="Modus wechseln"
  ></p-button>
</div>
<!-- ===== TITEL + IDENTIFIKATOR ===== -->
<div class="col mb-2">
  <div class="col">
    <label
      class="html-section-title"
      for="pvTitle"
      i18n="@@title"
      (click)="$event.stopPropagation()"
    >Titel</label>
  </div>
  <div class="col">
    <input
      pInputText
      id="pvTitle"
      type="text"
      pSize="small"
      fluid
      [(ngModel)]="this.fusionService.selectedHtmlPage.metadata.title"
      [ngModelOptions]="{updateOn: 'blur'}"
      (ngModelChange)="this.fusionService.updateFusionFieldFor(this.fusionService.selectedHtmlPage._id, 'title', this.fusionService.selectedHtmlPage.metadata.title)"
    >
    <small class="text-muted mt-1 d-block">
      <span i18n="@@fusion-view-name">Identifikator</span>: {{ this.fusionService.selectedHtmlPage.metadata.name }}
    </small>
  </div>
</div>
<!-- iFrame-Vorschau (nur URL-Modus) -->
@if (!this.fusionService.selectedHtmlPage.metadata.useStaticHtml) {
<div>
  <p
    class="text-secondary mb-3"
    i18n="@@remote-template-preview-desc"
  >
    Dieses Remote-Template wird verwendet, um die Fusion-View darzustellen.
  </p>
  <div class="row align-items-end mb-3">
    <div class="col">
      <label
        class="form-label fw-semibold"
        for="proxyUrlEditInput"
        i18n="@@url-proxy-label"
      >Template-URL</label>
      <input
        pInputText
        id="proxyUrlEditInput"
        type="text"
        pSize="small"
        fluid
        [(ngModel)]="this.editableProxyUrl"
      >
    </div>
    <div class="col-auto">
      <p-button
        size="small"
        severity="primary"
        icon="ri-refresh-line"
        [disabled]="!this.editableProxyUrl.trim() || this.editableProxyUrl === this.fusionService.selectedHtmlPage.metadata.proxyUrl"
        (onClick)="this.updateProxyUrl(this.editableProxyUrl)"
        i18n-label="@@update-proxy-url"
        label="URL aktualisieren"
      ></p-button>
    </div>
  </div>
  <div class="row mb-3">
    <div class="col">
      @if (this.safeHtml !== "") {
      <iframe [src]="this.safeHtml"></iframe>
      }
    </div>
  </div>
  <p-button
    size="small"
    [outlined]="true"
    severity="primary"
    icon="ri-file-copy-line"
    (onClick)="this.loadURL(this.fusionService.selectedHtmlPage.metadata.proxyUrl)"
    i18n-label="@@adopt-for-custom-editing"
    label="Für die individuelle Bearbeitung übernehmen"
  ></p-button>
</div>
}
<!-- ===== DARSTELLUNGSOPTIONEN (INITIAL) + PREVIEW ===== -->
<section class="html-section">
  <h6
    class="html-section-title"
    i18n="@@fusionconfig-display-options"
  >Darstellungsoptionen (Initial)</h6>
  <small
    class="html-section-hint"
    i18n="@@fusionconfig-display-options-hint"
  >
    Lege fest, wie der Bot und der Inhalt im Fusion-View dargestellt werden.
  </small>
  <div class="display-options-row">
    <div class="display-options-controls">
      <!-- Ansichtsmodus -->
      <div class="display-option-field">
        <p-select
          [options]="this.viewModeOptions"
          optionLabel="label"
          optionValue="value"
          [(ngModel)]="this.fusionService.selectedHtmlPage.metadata.viewMode"
          [ngModelOptions]="{updateOn: 'blur'}"
          (ngModelChange)="this.fusionService.updateFusionField('viewMode', this.fusionService.selectedHtmlPage.metadata.viewMode)"
        ></p-select>
      </div>
      <!-- Bot-Typ -->
      <div class="display-option-field">
        <p-selectbutton
          [options]="this.botTypeOptions"
          optionLabel="label"
          optionValue="value"
          [(ngModel)]="this.fusionService.selectedHtmlPage.metadata.bottype"
          (ngModelChange)="this.fusionService.updateFusionField('bottype', this.fusionService.selectedHtmlPage.metadata.bottype)"
          [unselectable]="true"
        >
          <ng-template
            let-item
            pTemplate="item"
          >
            <i
              [class]="item.icon"
              class="me-1"
            ></i>
            <span>{{ item.label }}</span>
          </ng-template>
        </p-selectbutton>
      </div>

      <!-- Bot anzeigen -->
      <div class="display-option-toggle">
        <p-toggleswitch
          [ngModel]="!this.fusionService.selectedHtmlPage.metadata.botHidden"
          (ngModelChange)="this.fusionService.selectedHtmlPage.metadata.botHidden = !$event; this.fusionService.updateFusionField('botHidden', this.fusionService.selectedHtmlPage.metadata.botHidden)"
        ></p-toggleswitch>
        <label
          class="form-label fw-semibold mb-0"
          i18n="@@fusionconfig-bot-visible"
        >Bot anzeigen</label>
      </div>

      <!-- Bot-Button anzeigen -->
      <div class="display-option-toggle">
        <p-toggleswitch
          [ngModel]="!this.fusionService.selectedHtmlPage.metadata.botButtonHidden"
          (ngModelChange)="this.fusionService.selectedHtmlPage.metadata.botButtonHidden = !$event; this.fusionService.updateFusionField('botButtonHidden', this.fusionService.selectedHtmlPage.metadata.botButtonHidden)"
        ></p-toggleswitch>
        <label
          class="form-label fw-semibold mb-0"
          i18n="@@fusionconfig-bot-button-visible"
        >Bot-Button anzeigen</label>
      </div>
      <!-- Disclaimer-Platzierung -->
      <div class="display-option-toggle">
        <p-toggleswitch
          [ngModel]="this.fusionService.selectedHtmlPage.metadata.disclaimerPlacement === 'fusionview'"
          (ngModelChange)="this.fusionService.selectedHtmlPage.metadata.disclaimerPlacement = $event ? 'fusionview' : 'botview'; this.fusionService.updateFusionField('disclaimerPlacement', this.fusionService.selectedHtmlPage.metadata.disclaimerPlacement)"
        ></p-toggleswitch>
        <label
          class="form-label fw-semibold mb-0"
          i18n="@@fusionconfig-disclaimer-over-fusionview"
        >Disclaimer über Fusion-View</label>
      </div>
      <!-- Systemsprache -->
      <div class="display-option-toggle">
        <label
          class="form-label fw-semibold mb-0"
          for="htmlpageLangSelect"
          i18n="@@fusionconfig-systemlang"
        >Systemsprache</label>
        <p-select
          id="htmlpageLangSelect"
          [options]="this.systemLanguageOptions"
          optionLabel="label"
          optionValue="value"
          [(ngModel)]="this.fusionService.selectedHtmlPage.metadata.botlang"
          (ngModelChange)="this.fusionService.updateFusionField('botlang', this.fusionService.selectedHtmlPage.metadata.botlang)"
        ></p-select>
      </div>
    </div>
  </div>
  <!-- Preview Wireframe -->
  <div class="display-preview">
    <div class="display-preview-frame">
      <!-- split -->
      @if (this.fusionService.selectedHtmlPage.metadata.viewMode === 'split' ||
      !this.fusionService.selectedHtmlPage.metadata.viewMode) {
      <div class="preview-split">
        <div class="preview-content-area">
          <div class="preview-content-line"></div>
          <div class="preview-content-line short"></div>
          <div class="preview-content-line"></div>
        </div>
        @if (!this.fusionService.selectedHtmlPage.metadata.botHidden) {
        <div class="preview-bot-area">
          <div class="preview-bot-header"></div>
          <div class="preview-bot-messages">
            <div class="preview-bot-bubble"></div>
            <div class="preview-bot-bubble user"></div>
          </div>
          <div class="preview-bot-input"></div>
        </div>
        }
      </div>
      }
      <!-- split-reverse: bot left, content right -->
      @if (this.fusionService.selectedHtmlPage.metadata.viewMode === 'split-reverse') {
      <div class="preview-split-reverse">
        <div class="preview-content-area">
          <div class="preview-content-line"></div>
          <div class="preview-content-line short"></div>
          <div class="preview-content-line"></div>
        </div>
        @if (!this.fusionService.selectedHtmlPage.metadata.botHidden) {
        <div class="preview-bot-area">
          <div class="preview-bot-header"></div>
          <div class="preview-bot-messages">
            <div class="preview-bot-bubble"></div>
            <div class="preview-bot-bubble user"></div>
          </div>
          <div class="preview-bot-input"></div>
        </div>
        }
      </div>
      }
      <!-- window -->
      @if (this.fusionService.selectedHtmlPage.metadata.viewMode === 'window') {
      <div class="preview-window">
        <div class="preview-content-area full">
          <div class="preview-content-line"></div>
          <div class="preview-content-line short"></div>
        </div>
        @if (!this.fusionService.selectedHtmlPage.metadata.botHidden) {
        <div class="preview-bot-overlay">
          <div class="preview-bot-header"></div>
          <div class="preview-bot-messages">
            <div class="preview-bot-bubble"></div>
            <div class="preview-bot-bubble user"></div>
          </div>
          <div class="preview-bot-input"></div>
        </div>
        }
      </div>
      }
      <!-- full -->
      @if (this.fusionService.selectedHtmlPage.metadata.viewMode === 'full') {
      <div class="preview-full">
        @if (!this.fusionService.selectedHtmlPage.metadata.botHidden) {
        <div class="preview-bot-area fullscreen">
          <div class="preview-bot-header"></div>
          <div class="preview-bot-messages">
            <div class="preview-bot-bubble"></div>
            <div class="preview-bot-bubble user"></div>
            <div class="preview-bot-bubble"></div>
          </div>
          <div class="preview-bot-input"></div>
        </div>
        }
        @if (this.fusionService.selectedHtmlPage.metadata.botHidden) {
        <div
          class="preview-hidden-label"
          i18n="@@fusionconfig-preview-hidden"
        >Bot ausgeblendet</div>
        }
      </div>
      }
      <!-- float -->
      @if (this.fusionService.selectedHtmlPage.metadata.viewMode === 'float') {
      <div class="preview-float">
        <div class="preview-content-area full">
          <div class="preview-content-line"></div>
          <div class="preview-content-line short"></div>
          <div class="preview-content-line"></div>
        </div>
        @if (!this.fusionService.selectedHtmlPage.metadata.botHidden) {
        <div class="preview-bot-float">
          <div class="preview-bot-header"></div>
          <div class="preview-bot-messages">
            <div class="preview-bot-bubble"></div>
            <div class="preview-bot-bubble user"></div>
          </div>
          <div class="preview-bot-input"></div>
        </div>
        }
      </div>
      }
      <!-- Bot hidden overlay -->
      @if (this.fusionService.selectedHtmlPage.metadata.botHidden &&
      this.fusionService.selectedHtmlPage.metadata.viewMode !== 'full') {
      <div class="preview-hidden-overlay">
        <div class="preview-content-line"></div>
        <div class="preview-content-line short"></div>
        <div class="preview-content-line"></div>
      </div>
      }
      <!-- Bot-Toggle-Button (FAB) -->
      @if (!this.fusionService.selectedHtmlPage.metadata.botButtonHidden) {
      <div class="preview-bot-fab">
        <i class="ri-chat-3-line"></i>
      </div>
      }
    </div>
  </div>
</section>
<!-- ===== POSITION ===== -->
<div class="col mt-2">
  <label
    class="text-secondary me-2 col col-form-label"
    for="pvBotPosition"
    i18n="@@fusion-view-position"
    (click)="$event.stopPropagation()"
  >Position</label>
  <input
    pInputText
    id="pvBotPosition"
    type="number"
    pSize="small"
    min="1"
    [(ngModel)]="this.fusionService.selectedHtmlPage.metadata.sortFloat"
    [ngModelOptions]="{updateOn: 'blur'}"
    (ngModelChange)="this.fusionService.updateFusionField('sortFloat',this.fusionService.selectedHtmlPage.metadata.sortFloat)"
  >
</div>
<!-- Custom JavaScript -->
<section class="html-section">
  <h6
    class="html-section-title"
    i18n="@@fusion-logic-editor-heading"
  >Logik-Editor</h6>
  <p
    class="html-section-hint"
    i18n="@@fusion-logic-editor-description"
  >
    Im Logik-Editor kannst du Abläufe und Regeln für diesen Fusion-View per Scripting anpassen.
  </p>
  <p-button
    [outlined]="true"
    severity="primary"
    size="small"
    icon="ri-code-box-line"
    [gotoBlockly]="this.editorItemService.getEditorItemByUniqueId('fusion_' + this.fusionService.selectedHtmlPage._id)"
    i18n-label="@@to-scripting"
    label="Zum Scripting"
  ></p-button>
</section>
@if (this.fusionService.selectedHtmlPage.metadata.useStaticHtml) {
<section class="html-section">
  <h6 class="html-section-title">
    <i class="ri-code-s-slash-line me-1"></i>
    <span i18n="@@fusionconfig-html-advanced">HTML-Editor (Erweitert)</span>
  </h6>
  <p
    class="html-section-hint"
    i18n="@@fusionconfig-html-hint"
  >
    Hier kannst du das HTML des Fusion-Views direkt bearbeiten. Nur für erfahrene Nutzer empfohlen.
  </p>
  <p-button
    [outlined]="true"
    [severity]="showHtmlEditor ? 'primary' : 'secondary'"
    size="small"
    [icon]="showHtmlEditor ? 'ri-eye-off-line' : 'ri-code-s-slash-line'"
    (onClick)="showHtmlEditor = !showHtmlEditor"
    [label]="showHtmlEditor ? 'Editor ausblenden' : 'Editor einblenden'"
  ></p-button>
  @if (showHtmlEditor) {
  <div class="mt-3">
    <app-codemirror-html
      [code]="this.fusionService.selectedHtmlPage.metadata.staticHtml"
      (finish)="this.fusionService.selectedHtmlPage.metadata.staticHtml = $event.code; this.fusionService.updateFusionField('staticHtml', this.fusionService.selectedHtmlPage.metadata.staticHtml)"
    ></app-codemirror-html>
    <button
      pButton
      i18n-label="@@show-placeholders"
      label="Platzhalter anzeigen"
      icon="pi pi-info-circle"
      severity="secondary"
      size="small"
      class="mt-2"
      [appPlaceholderInfo]="'basic'"
    ></button>
  </div>
  }
</section>
}
}